<template>
  <div class="">
    <Product v-for="product in products" key="product.id" :id="product.name" :product="product"></Product>
  </div>
</template>

<script>

import Product from './products/ProductComponent'

export default {
  mounted() {},
  components: {
    Product
  },
  methods: {},
  computed: {
    products() {
      return this.$store.state.productList
    }
  },
  watch: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductWrapper.vue?66014ac9